import { useMemo } from 'react';
import { Button, Card, Col, Row } from 'react-bootstrap';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { BootstrapGenericTable } from '@components/Table';

const renderActionsCell = ({ row }) => {
  const navigate = useNavigate();
  const { id } = row.original;
  return (
    <Button
      className="btn-sm"
      variant="didxl"
      onClick={() => navigate(`/capacity/did-groups/${id}/edit`)}
      size="sm"
    >
      Edit DID-Group
    </Button>
  );
};

export const DidGroupsExistingTable = ({ useData }) => {
  const navigate = useNavigate();
  const [searchParams, _] = useSearchParams();
  const country = searchParams.get('country');
  const plan = searchParams.get('plan');
  const name = searchParams.get('name');
  const planType = searchParams.get('type');
  const filterData = {
    country,
    plan,
    type: planType,
    name,
  };
  const columns = useMemo(
    () => [
      {
        id: 'name',
        Header: 'DID-Group',
        accessor: 'name',
        className: 'col-md-3',
      },
      {
        id: 'country',
        Header: 'Country',
        accessor: 'country',
        className: 'col-md-3 text-center',
      },
      {
        id: 'plan',
        Header: 'Plan',
        accessor: 'plan',
        className: 'col-md-1 text-center',
      },
      {
        id: 'channel_amount',
        Header: 'Shared Channels',
        accessor: 'channel_amount',
        className: 'col-md-1 text-center',
      },
      {
        id: 'action',
        Header: 'Action',
        Cell: renderActionsCell,
        className: 'col-md-2 text-center',
      },
    ],
    []
  );
  return (
    <Card>
      <Card.Header className="bg-didxl text-white">
        <Row>
          <Col>My DID-Groups</Col>
          <Col className="text-end">
            <Button
              className="btn-sm"
              variant="didxl"
              onClick={() => navigate(`/capacity/did-groups/new`)}
              size="sm"
            >
              Add DID-Group
            </Button>
          </Col>
        </Row>
      </Card.Header>
      <Card.Body>
        <BootstrapGenericTable
          columns={columns}
          useData={useData}
          filterData={filterData}
          tableProps={() => ({
            responsive: true,
            bordered: true,
            className: 'normalFontSize',
          })}
          paginated
        />
      </Card.Body>
    </Card>
  );
};
